export const PIX_EXPIRATION_TIME = 600

export const getExpirationSeconds = created =>
  PIX_EXPIRATION_TIME + Math.round(new Date(created.replace('Z', '')).getTime() - new Date().getTime()) / 1000

